/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Sq_Rev2_RoleInputs */

const en_funnel_sq_rev2_role = /** @type {(inputs: Funnel_Sq_Rev2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undergrad · dyslexia`)
};

const es_funnel_sq_rev2_role = /** @type {(inputs: Funnel_Sq_Rev2_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estudiante de grado · dislexia`)
};

/**
* | output |
* | --- |
* | "Undergrad · dyslexia" |
*
* @param {Funnel_Sq_Rev2_RoleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_sq_rev2_role = /** @type {((inputs?: Funnel_Sq_Rev2_RoleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Sq_Rev2_RoleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_sq_rev2_role(inputs)
	return en_funnel_sq_rev2_role(inputs)
});